/**
 * Login
 */

// React
import React, {useState, useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {loginAction, generateOptAction, verifyOtpAction} from './actions';

import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {makeSelectToken, makeSelectLoading, makeSelectError} from './selectors';

// UI
import {makeStyles} from '@material-ui/core/styles';
import {
  Button,
  TextField,
  Avatar,
  Grid,
  CircularProgress,
  Paper,
  Typography,
  Box,
  Link,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Countdown from 'react-countdown';

// Helper
import {fixNumbers} from '../../utils/helpers';

// Type
import {Props, SelectorProps, Payload, PayloadGenerateOpt} from './interfaces';

// Style
const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url("/login.JPG")',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    margin: theme.spacing(1, 0, 3),
    padding: theme.spacing(0, 8),
  },
  error: {
    margin: theme.spacing(2, 0, 0),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Login(props: Props) {
  const [emailAddress, setEmailAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [mode, setMode] = useState('generateOpt');
  const [rememberMe] = useState(true);

  const [completions, setCompletions] = useState(0);

  useEffect(() => {
    localStorage.removeItem('token');
  }, []);

  const handleChangeEmailAddress = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmailAddress(event.target.value);
  };
  const handleChangePhoneNumber = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhoneNumber(event.target.value);
  };
  const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (mode === 'default' && emailAddress.length > 0 && password.length > 0) {
      props.loginDispatch({
        emailAddress,
        password,
        rememberMe,
      });
    } else if (mode === 'generateOpt') {
      props.generateOptDispatch({
        phoneNumber: fixNumbers(`${phoneNumber}`),
        callback: () => setMode('verifyOpt'),
      });
    } else if (mode === 'verifyOpt') {
      props.verifyOptDispatch({
        code: fixNumbers(`${code}`),
        phoneNumber: fixNumbers(`${phoneNumber}`),
        rememberMe: true,
      });
    }
  };
  const changeModeLogin = (mode: string) => {
    setMode(mode);
  };

  const classes = useStyles();
  return (
    <>
      <Grid container component="main" className={classes.root}>
        <Grid
          item
          xs={12}
          md={4}
          component={Paper}
          // elevation={6}
          square
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <div className={classes.paper}>
            <Avatar
              className={classes.avatar}
              src="/logo-dark.svg"
              variant="square"
            />
            <Typography component="h1" variant="h5">
              {'به پنل راننده خوش آمدید‬'}
            </Typography>

            <form className={classes.form}>
                <>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="phoneNumber"
                    label=" شماره موبایل"
                    name="phoneNumber"
                    autoFocus
                    value={phoneNumber}
                    onChange={handleChangePhoneNumber}
                  />
                </>

              {mode === 'verifyOpt' && (
                <>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="code"
                    label="کد"
                    name="code"
                    autoFocus
                    value={code}
                    onChange={handleChangeCode}
                  />
                  <Typography variant="caption" display="block" gutterBottom>
                    شماره موبایل وارد شده:
                    {phoneNumber}
                  </Typography>

                  <Countdown
                    date={Date.now() + 120000}
                    key={completions}
                    onComplete={() => setMode('verifyOpt')}
                    renderer={({minutes, seconds, completed}) => {
                      if (completed) {
                        return (
                          <div>
                            <span>
                              {minutes}:{seconds}
                            </span>
                            <Button
                              color="primary"
                              variant="outlined"
                              onClick={e => {
                                setCompletions(completions + 1);
                                props.generateOptDispatch({
                                  phoneNumber: fixNumbers(`${phoneNumber}`),
                                  callback: () => setMode('verifyOpt'),
                                });
                              }}
                            >
                              درخواست مجدد کد
                            </Button>
                          </div>
                        );
                      } else {
                        return (
                          <div>
                            {minutes}:{seconds}
                          </div>
                        );
                      }
                    }}
                  />
                </>
              )}

              {props.error == 'not-for-this' && mode === 'default' ? (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره
                  امتحان نمایید
                </Alert>
              ) : (
                props.error &&
                mode === 'default' && (
                  <Alert
                    variant="filled"
                    severity="error"
                    className={classes.error}
                  >
                    ورود ناموفق، لطفا نام‌کاربری و کلمه عبور را بررسی و دوباره
                    امتحان نمایید
                  </Alert>
                )
              )}
              {props.error && mode === 'generateOpt' && (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  شماره موبایل در سیستم ثبت نشده است
                </Alert>
              )}
              {props.error && mode === 'verifyOpt' && (
                <Alert
                  variant="filled"
                  severity="error"
                  className={classes.error}
                >
                  ورود ناموفق، لطفا دوباره امتحان نمایید
                </Alert>
              )}

              {mode === 'default' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{minWidth: '25%'}}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={props.loading}
                >
                  {mode === 'default' && 'ورود'}
                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}
              {mode === 'verifyOpt' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{minWidth: '25%'}}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={props.loading}
                >
                  {mode === 'verifyOpt' && 'ورود'}
                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}
              {mode === 'generateOpt' && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{minWidth: '25%'}}
                  className={classes.submit}
                  onClick={e => onSubmit(e)}
                  disabled={phoneNumber.length === 0}
                >
                  {mode === 'generateOpt' && 'دریافت کد'}

                  {props.loading && <CircularProgress size={24} />}
                </Button>
              )}

              <Grid container>
                {/* {mode === 'default' ? ( */}
                  {/* <Grid item xs>
                    <Button onClick={() => changeModeLogin('generateOpt')}>
                      {' '}
                      ورود با شماره موبایل
                    </Button>
                  </Grid> */}
                {/* ) : (
                  <Grid item xs>
                    <Button onClick={() => changeModeLogin('default')}>
                      {' '}
                      ورود با ایمیل{' '}
                    </Button>
                  </Grid>
                )} */}
              </Grid>
            </form>
            {/*             <Box mt={8}>
              <Typography variant="body2" color="textSecondary" align="center">
                {'شماره پشتیبانی '}
                <Link color="inherit" href="tel:02153850538">
                  53850538 - 021
                </Link>{' '}
              </Typography>
            </Box> */}
          </div>
        </Grid>
        <Grid item xs={false} md={8} className={classes.image} />
      </Grid>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  token: makeSelectToken(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    loginDispatch: (payload: Payload) => dispatch(loginAction(payload)),
    generateOptDispatch: (payload: PayloadGenerateOpt) =>
      dispatch(generateOptAction(payload)),
    verifyOptDispatch: (payload: {
      code: string;
      phoneNumber: string;
      rememberMe: boolean;
    }) => dispatch(verifyOtpAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Login);
